import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { ctcAnalysisColors, statusColors } from './CommonFunction'
import { PDFFooter } from './PDFFooter'
import { PDFHeader } from './PDFHeader'
import { PDFImageWithLegend } from './PDFImageWithLegend'
import { PDFTable } from './PDFTable'
import { PDFTitleDetails } from './PDFTitleDetails'

export const DonutChartPDF = async ({
  initialHeight,
  chartElement,
  selectedCourseArr,
  data,
  headers,
  legend,
  exportData,
  instituteDetails,
  headerImage,
  state,
}) => {
  const { selectedCategory } = state
  const placement = selectedCategory === 'PLACEMENT'
  const gigs = selectedCategory === 'GIGS'

  let currentY = initialHeight
  const pdf = new jsPDF('p', 'mm', 'a4')
  const pageHeight = pdf.internal.pageSize.height

  // job profile status graph
  if (chartElement?.jobProfileStatusRef && exportData?.jobProfileStatus) {
    await PDFHeader({
      pdf,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
    })
    const jobProfileCanvas = await html2canvas(
      chartElement?.jobProfileStatusRef
    )
    const jobProfileImageData = jobProfileCanvas.toDataURL('image/png')

    currentY += 50

    currentY = await PDFTitleDetails({
      pdf,
      pageHeight,
      currentY,
      selectedCourseArr,
      title: 'Job Profile Status',
      selectedCategory,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.selectedPassingYear,
    })

    const imgWidth = 60 // Adjusted width for A4
    const imgHeight =
      (jobProfileCanvas.height * imgWidth) / jobProfileCanvas.width

    if (currentY + imgHeight > pageHeight - 20) {
      pdf.addPage()

      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.selectedPassingYear,
      })

      currentY = 50
    }

    currentY = await PDFImageWithLegend({
      pdf,
      imgData: jobProfileImageData,
      currentY,
      imgWidth,
      imgHeight,
      data: legend?.jobProfile,
      pageHeight,
      statusColors,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.selectedPassingYear,
    })

    // Update currentY after drawing the legend
    currentY += imgHeight + 10
    currentY = await PDFTable({
      pdf,
      currentY,
      headers: headers?.jobProfile,
      data: data?.studentPlacementData,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.selectedPassingYear,
      statusColors,

      columnStyles: {
        0: { halign: 'center' },
        1: { textColor: [255, 255, 255] }, // Hide default text
        2: { halign: 'center' },
      },
    })
  }
  PDFFooter({ pdf })
  //

  //job profile status compare pdf

  if (
    chartElement?.compareJobProfileStatusRef &&
    exportData?.jobProfileStatus
  ) {
    pdf.addPage()

    await PDFHeader({
      pdf,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.compareYear,
    })
    currentY = 20

    const jobProfileCanvas = await html2canvas(
      chartElement?.compareJobProfileStatusRef
    )
    const jobProfileImageData = jobProfileCanvas.toDataURL('image/png')

    currentY += currentY + 10

    currentY = await PDFTitleDetails({
      pdf,
      pageHeight,
      currentY,
      selectedCourseArr,
      title: 'Job Profile Status',
      selectedCategory,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.compareYear,
    })
    PDFFooter({ pdf })

    const imgWidth = 60 // Adjusted width for A4
    const imgHeight =
      (jobProfileCanvas.height * imgWidth) / jobProfileCanvas.width

    if (currentY + imgHeight > pageHeight - 20) {
      pdf.addPage()
      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.compareYear,
      })
      currentY = 50
    }

    currentY = await PDFImageWithLegend({
      pdf,
      imgData: jobProfileImageData,
      currentY,
      imgWidth,
      imgHeight,
      data: legend?.compareJobProfileStatus,
      pageHeight,
      statusColors,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.compareYear,
    })

    // Update currentY after drawing the legend
    currentY += imgHeight + 10

    currentY = await PDFTable({
      pdf,
      currentY,
      headers: headers?.compareJobProfile,
      data: data?.compareJobProfileStatusData,
      statusColors,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.compareYear,
      columnStyles: {
        0: { halign: 'center' },
        1: { textColor: [255, 255, 255] }, // Hide default text
        2: { halign: 'center' },
      },
    })
  }

  PDFFooter({ pdf })

  // currentY = pdf.autoTable.previous.finalY + 10

  // student placement pdf

  if (chartElement?.studentPlacementRef && exportData?.studentPlacement) {
    if (exportData?.jobProfileStatus) {
      pdf.addPage()
    }
    await PDFHeader({
      pdf,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
    })
    currentY = 50
    currentY = await PDFTitleDetails({
      pdf,
      pageHeight,
      currentY,
      selectedCourseArr,
      title: placement ? 'Student Placement' : 'Student Placed',
      selectedCategory,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
    })
    PDFFooter({ pdf })
    //

    const studentPlacementCanvas = await html2canvas(
      chartElement?.studentPlacementRef
    )
    const studentPlacementImageData =
      studentPlacementCanvas.toDataURL('image/png')

    const studentImgWidth = 60 // Adjusted width for A4
    const studentImgHeight =
      (studentPlacementCanvas.height * studentImgWidth) /
      studentPlacementCanvas.width

    if (currentY + studentImgHeight > pageHeight - 20) {
      pdf.addPage()
      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.selectedPassingYear,
      })
      currentY = 50
    }

    currentY = await PDFImageWithLegend({
      pdf,
      imgData: studentPlacementImageData,
      currentY,
      imgWidth: studentImgWidth,
      imgHeight: studentImgHeight,
      data: legend?.studentPlacement,
      pageHeight,
      statusColors,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.selectedPassingYear,
    })
    currentY += studentImgHeight + 10
    currentY = await PDFTable({
      pdf,
      currentY,
      headers: headers?.studentPlacement,
      data: data?.studentPlacement,
      statusColors,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.selectedPassingYear,
      columnStyles: {
        0: { halign: 'center' },
        1: { textColor: [255, 255, 255] }, // Hide default text
        2: { halign: 'center', textColor: [255, 255, 255] },
      },
    })
    currentY += 10
    currentY = await PDFTable({
      pdf,
      currentY,
      headers: headers?.optOutStatus,
      data: data?.optOutStatus,
      statusColors,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.selectedPassingYear,
      columnStyles: {
        0: { halign: 'center' },
        1: { textColor: [255, 255, 255] }, // Hide default text
        2: { halign: 'center', textColor: [255, 255, 255] },
      },
    })

    PDFFooter({ pdf })
    if (state?.compareYear && chartElement?.compareStudentPlacementRef) {
      pdf.addPage()
      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.compareYear,
      })
      currentY = 50
    }
  }

  // compare student placement

  if (
    chartElement?.compareStudentPlacementRef &&
    exportData?.studentPlacement
  ) {
    currentY = await PDFTitleDetails({
      pdf,
      pageHeight,
      currentY,
      selectedCourseArr,
      title: placement ? 'Student Placement' : 'Student Placed',
      selectedCategory,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.compareYear,
    })
    PDFFooter({ pdf })

    const studentPlacementCanvas = await html2canvas(
      chartElement?.compareStudentPlacementRef
    )
    const studentPlacementImageData =
      studentPlacementCanvas.toDataURL('image/png')

    const studentImgWidth = 60 // Adjusted width for A4
    const studentImgHeight =
      (studentPlacementCanvas.height * studentImgWidth) /
      studentPlacementCanvas.width

    if (currentY + studentImgHeight > pageHeight - 20) {
      pdf.addPage()
      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.compareYear,
      })
      currentY = 50
    }

    currentY = await PDFImageWithLegend({
      pdf,
      imgData: studentPlacementImageData,
      currentY,
      imgWidth: studentImgWidth,
      imgHeight: studentImgHeight,
      data: legend?.compareStudentPlacement,
      pageHeight,
      statusColors,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.compareYear,
    })
    currentY += studentImgHeight + 10
    currentY = await PDFTable({
      pdf,
      currentY,
      headers: headers?.studentPlacement,
      data: data?.compareStudentPlacement,
      statusColors,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.compareYear,
      columnStyles: {
        0: { halign: 'center' },
        1: { textColor: [255, 255, 255] }, // Hide default text
        2: { halign: 'center', textColor: [255, 255, 255] },
      },
    })
    currentY += 10
    currentY = await PDFTable({
      pdf,
      currentY,
      headers: headers?.optOutStatus,
      data: data?.optOutStatus,
      statusColors,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.compareYear,
      columnStyles: {
        0: { halign: 'center' },
        1: { textColor: [255, 255, 255] }, // Hide default text
        2: { halign: 'center', textColor: [255, 255, 255] },
      },
    })
  }
  PDFFooter({ pdf })

  //ctc analysis graph

  if (chartElement?.ctcAnalysisRef && exportData?.ctcBased) {
    if (exportData?.jobProfileStatus || exportData?.studentPlacement) {
      pdf.addPage()
    }

    await PDFHeader({
      pdf,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
    })
    currentY = 50
    currentY = await PDFTitleDetails({
      pdf,
      pageHeight,
      currentY,
      selectedCourseArr,
      title: placement
        ? 'CTC Analysis'
        : gigs
        ? 'CTC Analysis'
        : 'Stipend Analysis',
      selectedCategory,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
    })
    PDFFooter({ pdf })
    //

    const ctcAnalysisCanvas = await html2canvas(chartElement?.ctcAnalysisRef)
    const ctcAnalysisImageData = ctcAnalysisCanvas.toDataURL('image/png')

    const ctcAnalysisImgWidth = 100 // Adjusted width for A4
    const ctcAnalysisImgHeight =
      (ctcAnalysisCanvas.height * ctcAnalysisImgWidth) / ctcAnalysisCanvas.width

    if (currentY + ctcAnalysisImgHeight > pageHeight - 20) {
      pdf.addPage()
      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.selectedPassingYear,
      })
      currentY = 50
    }

    currentY = await PDFImageWithLegend({
      pdf,
      imgData: ctcAnalysisImageData,
      currentY,
      imgWidth: ctcAnalysisImgWidth,
      imgHeight: ctcAnalysisImgHeight,
      data: data?.ctcAnalysis,
      pageHeight,
      statusColors: ctcAnalysisColors,
      legend: false,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
    })
    currentY += ctcAnalysisImgHeight + 10
    currentY = await PDFTable({
      pdf,
      currentY,
      headers: headers?.ctcAnalysis,
      data: data?.ctcAnalysis,
      statusColors: ctcAnalysisColors,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
      columnStyles: {
        0: { halign: 'center' },
        1: { textColor: [255, 255, 255] }, // Hide default text
        2: { halign: 'center' },
        3: { textColor: [255, 255, 255] }, // Hide default text
      },
      type: 'ctcAnalysis',
    })
    PDFFooter({ pdf })
    if (state?.compareYear && chartElement?.compareCtcAnalysisRef) {
      pdf.addPage()
      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.compareYear,
      })
      currentY = 50
    }
  }

  // compare ctc analysis graph pdf

  if (chartElement?.compareCtcAnalysisRef && exportData?.ctcBased) {
    currentY = await PDFTitleDetails({
      pdf,
      pageHeight,
      currentY,
      selectedCourseArr,
      title: placement
        ? 'CTC Analysis'
        : gigs
        ? 'CTC Analysis'
        : 'Stipend Analysis',
      selectedCategory,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.compareYear,
    })
    PDFFooter({ pdf })

    const ctcAnalysisCanvas = await html2canvas(
      chartElement?.compareCtcAnalysisRef
    )
    const ctcAnalysisImageData = ctcAnalysisCanvas.toDataURL('image/png')

    const ctcAnalysisImgWidth = 60 // Adjusted width for A4
    const ctcAnalysisImgHeight =
      (ctcAnalysisCanvas.height * ctcAnalysisImgWidth) / ctcAnalysisCanvas.width

    if (currentY + ctcAnalysisImgHeight > pageHeight - 20) {
      pdf.addPage()

      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.compareYear,
      })

      currentY = 50
    }

    currentY = await PDFImageWithLegend({
      pdf,
      imgData: ctcAnalysisImageData,
      currentY,
      imgWidth: ctcAnalysisImgWidth,
      imgHeight: ctcAnalysisImgHeight,
      data: data?.compareCtcAnalysis,
      pageHeight,
      statusColors: ctcAnalysisColors,
      legend: false,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.compareYear,
    })
    currentY += ctcAnalysisImgHeight + 10
    currentY = await PDFTable({
      pdf,
      currentY,
      headers: headers?.ctcAnalysis,
      data: data?.compareCtcAnalysis,
      statusColors: ctcAnalysisColors,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.compareYear,
      columnStyles: {
        0: { halign: 'center' },
        1: { textColor: [255, 255, 255] }, // Hide default text
        2: { halign: 'center' },
        3: { textColor: [255, 255, 255] }, // Hide default text
      },
      type: 'ctcAnalysis',
    })
  }

  PDFFooter({ pdf })

  // ctc category graph pdf generation

  if (chartElement?.ctcCategoryRef && exportData?.ctcCategory) {
    if (
      exportData?.jobProfileStatus ||
      exportData?.studentPlacement ||
      exportData?.ctcBased
    ) {
      pdf.addPage()
    }

    await PDFHeader({
      pdf,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
    })
    currentY = 50

    currentY = await PDFTitleDetails({
      pdf,
      pageHeight,
      currentY,
      selectedCourseArr,
      title: placement
        ? 'CTC Category'
        : gigs
        ? 'CTC Category'
        : 'Stipend Category',
      selectedCategory,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
    })
    PDFFooter({ pdf })

    const ctcCategoryCanvas = await html2canvas(chartElement?.ctcCategoryRef, {
      scale: 2, // High-resolution rendering
      useCORS: true, // Optional: allows cross-origin images if any
    })
    const ctcCategoryImageData = ctcCategoryCanvas.toDataURL('image/png')

    const ctcCategoryImgWidth = 150 // Adjusted width for A4
    const ctcCategoryImgHeight =
      (ctcCategoryCanvas.height * ctcCategoryImgWidth) / ctcCategoryCanvas.width

    if (currentY + ctcCategoryImgHeight > pageHeight - 20) {
      pdf.addPage()

      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.selectedPassingYear,
      })

      currentY = 50
    }

    currentY = await PDFImageWithLegend({
      pdf,
      imgData: ctcCategoryImageData,
      currentY,
      imgWidth: ctcCategoryImgWidth,
      imgHeight: ctcCategoryImgHeight,
      data: data?.ctcCategory,
      pageHeight,
      statusColors,
      legend: false,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
    })
    currentY += ctcCategoryImgHeight + 10
    currentY = await PDFTable({
      pdf,
      currentY,
      headers: headers?.ctcCategory,
      data: data?.ctcCategory,
      statusColors,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.selectedPassingYear,
      columnStyles: {
        0: { halign: 'center', textColor: [255, 255, 255] },
        1: { textColor: [255, 255, 255] }, // Hide default text
        2: { halign: 'center', textColor: [255, 255, 255] },
      },
      type: 'ctcCategory',
    })
    PDFFooter({ pdf })
    if (state?.compareYear && chartElement?.compareCtcCategoryRef) {
      pdf.addPage()

      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.compareYear,
      })
      currentY = 50
    }
  }
  if (chartElement?.compareCtcCategoryRef && exportData?.ctcCategory) {
    currentY = await PDFTitleDetails({
      pdf,
      pageHeight,
      currentY,
      selectedCourseArr,
      title: placement
        ? 'CTC Category'
        : gigs
        ? 'CTC Category'
        : 'Stipend Category',
      selectedCategory,
      headerImage,
      instituteDetails,
      chartElement,
      year: state?.compareYear,
    })
    PDFFooter({ pdf })

    const ctcCategoryCanvas = await html2canvas(
      chartElement?.compareCtcCategoryRef,
      {
        scale: 2, // High-resolution rendering
        useCORS: true, // Optional: allows cross-origin images if any
      }
    )
    const ctcCategoryImageData = ctcCategoryCanvas.toDataURL('image/png')

    const ctcCategoryImgWidth = 150 // Adjusted width for A4
    const ctcCategoryImgHeight =
      (ctcCategoryCanvas.height * ctcCategoryImgWidth) / ctcCategoryCanvas.width

    if (currentY + ctcCategoryImgHeight > pageHeight - 20) {
      pdf.addPage()

      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year: state?.compareYear,
      })

      currentY = 50
    }

    currentY = await PDFImageWithLegend({
      pdf,
      imgData: ctcCategoryImageData,
      currentY,
      imgWidth: ctcCategoryImgWidth,
      imgHeight: ctcCategoryImgHeight,
      data: data?.compareCtcCategory,
      pageHeight,
      statusColors,
      legend: false,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.compareYear,
    })
    currentY += ctcCategoryImgHeight + 10
    currentY = await PDFTable({
      pdf,
      currentY,
      headers: headers?.ctcCategory,
      data: data?.compareCtcCategory,
      statusColors,
      headerImage,
      chartElement,
      instituteDetails,
      year: state?.compareYear,
      columnStyles: {
        0: { halign: 'center', textColor: [255, 255, 255] },
        1: { textColor: [255, 255, 255] }, // Hide default text
        2: { halign: 'center', textColor: [255, 255, 255] },
      },
      type: 'ctcCategory',
    })
  }
  PDFFooter({ pdf })

  const pdfBlob = pdf.output('blob')
  return pdfBlob
}
